export const fa_number = (number) => {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    return number
        .toString()
        .split('')
        .map(x => {
            if (x !== ',')
                return farsiDigits[x];

            return x;
        })
        .join('');
}

export const fa_currency = (number) => {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    return number
        .toFixed(0)
        .replace(new RegExp(/(\d)(?=(\d{3})+(?!\d))/g, 'g'), '$&,')
        .split('')
        .map((x) => {
            if (x !== ',')
                return farsiDigits[x];

            return ',';
        })
        .join('');
}

export const fa_date = (date) => {
    // let options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(date).toLocaleDateString('fa-IR', {year:'numeric',month:'long',day:'2-digit',hour:'numeric',minute:'numeric',formatMatcher:'basic'})
}

export const fa_dateـetime = (date) => {
    // let options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(date).toLocaleDateString('fa-IR', {year:'numeric',month:'long',day:'2-digit',formatMatcher:'basic'})
}